import React, { useState, useEffect } from 'react';
import { bannerApi } from '../../config/api.config';

const BannerEditModal = ({ isOpen, onClose, banner, onSuccess }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [previewUrl, setPreviewUrl] = useState('');
    const [title, setTitle] = useState('');
    const [linkUrl, setLinkUrl] = useState('');
    const [placement, setPlacement] = useState('home_top');
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        if (banner) {
            setTitle(banner.title || '');
            setLinkUrl(banner.linkUrl || '');
            setPlacement(banner.placement || 'home_top');
            setIsActive(banner.isActive || false);
            setPreviewUrl(banner.imageUrl || '');
        }
    }, [banner]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            
            // 미리보기 URL 생성
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreviewUrl(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!title.trim()) {
            alert('배너 제목을 입력해주세요.');
            return;
        }

        setLoading(true);

        try {
            if (selectedFile) {
                // 새 파일이 있는 경우 multipart/form-data 사용
                const formData = new FormData();
                formData.append('title', title);
                formData.append('linkUrl', linkUrl);
                formData.append('placement', placement);
                formData.append('isActive', isActive.toString());
                formData.append('image', selectedFile);

                await bannerApi.patch(`/admin/${banner.id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
            } else {
                // 파일이 없는 경우 JSON 사용
                const updateData = {
                    title: title,
                    linkUrl: linkUrl,
                    placement: placement,
                    isActive: isActive
                };

                await bannerApi.patch(`/admin/${banner.id}`, updateData, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
            }

            alert('배너가 성공적으로 수정되었습니다.');
            onSuccess();
            onClose();
        } catch (error) {
            console.error('배너 수정 실패:', error);
            alert('배너 수정에 실패했습니다.');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSelectedFile(null);
        setPreviewUrl('');
        setTitle('');
        setLinkUrl('');
        setPlacement('home_top');
        setIsActive(true);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '24px',
                width: '90%',
                maxWidth: '500px',
                maxHeight: '90vh',
                overflow: 'auto'
            }}>
                <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', fontWeight: 'bold' }}>
                    배너 수정
                </h3>

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
                            배너 제목 *
                        </label>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                            placeholder="배너 제목을 입력하세요"
                        />
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
                            링크 URL
                        </label>
                        <input
                            type="url"
                            value={linkUrl}
                            onChange={(e) => setLinkUrl(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                            placeholder="https://example.com"
                        />
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
                            배치 위치
                        </label>
                        <select
                            value={placement}
                            onChange={(e) => setPlacement(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                        >
                            <option value="home_top">홈 상단</option>
                            <option value="search_result">검색 결과</option>
                            <option value="category">카테고리</option>
                        </select>
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '500' }}>
                            <input
                                type="checkbox"
                                checked={isActive}
                                onChange={(e) => setIsActive(e.target.checked)}
                            />
                            활성화
                        </label>
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
                            배너 이미지 (선택사항)
                        </label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{
                                width: '100%',
                                padding: '8px 12px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '14px'
                            }}
                        />
                        <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                            새 이미지를 선택하지 않으면 기존 이미지가 유지됩니다.
                        </div>
                    </div>

                    {previewUrl && (
                        <div style={{ marginBottom: '16px' }}>
                            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
                                이미지 미리보기
                            </label>
                            <img
                                src={previewUrl}
                                alt="미리보기"
                                style={{
                                    width: '100%',
                                    maxHeight: '200px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    border: '1px solid #ddd'
                                }}
                            />
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                        <button
                            type="button"
                            onClick={handleClose}
                            style={{
                                padding: '8px 16px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                backgroundColor: 'white',
                                color: '#333',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                            disabled={loading}
                        >
                            취소
                        </button>
                        <button
                            type="submit"
                            style={{
                                padding: '8px 16px',
                                border: 'none',
                                borderRadius: '4px',
                                backgroundColor: '#1976d2',
                                color: 'white',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                opacity: loading ? 0.6 : 1
                            }}
                            disabled={loading}
                        >
                            {loading ? '수정 중...' : '수정'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BannerEditModal;
